import PropTypes from 'prop-types'
import React from 'react'
import './index.css'
import Offscreen from 'ui/Offscreen'

const WarehouseSetupFinishTile = props => {
  const { bitool } = props
  const style = { backgroundImage: `url("${bitool.logo}")` }

  return (
    <li className='WarehouseSetupFinishTile'>
      <a className='WarehouseSetupFinishTile-link' href={bitool.website} onClick={track(bitool.name)} rel='external' target='_blank'>
        <span className='WarehouseSetupFinishTile-logo' style={style}>
          <Offscreen>
            {bitool.name}
          </Offscreen>
        </span>
      </a>
    </li>
  )
}

/**
 * Track clicks on the <Tile>.
 */

function track (name) {
  return function () {
    window.analytics.track('Clicked SQL Integration', {
      partner_name: name,
      workspace_id: window.segment.workspace.id // shutup
    })
  }
}

WarehouseSetupFinishTile.displayName = 'WarehouseSetupFinishTile'

WarehouseSetupFinishTile.propTypes = {
  bitool: PropTypes.object.isRequired
}

export default WarehouseSetupFinishTile



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/components/warehouse-setup-finish-tile/index.js